/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Paper,
} from '@mui/material';
import Loading from '../Loading';
import api from '../../utils/functions/api';
import { useNavigate } from 'react-router-dom';

import QRCode from './QRCode';
import QRCredit from './QRCredit';
import QRAllInOne from './QRAllInOne';

import QrCodeIcon from '@mui/icons-material/QrCode';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import QrCode2Icon from '@mui/icons-material/QrCode2';

import thai_qr_logo from '../../assets/images/thai_qr_logo.png';
import creditcardLogo from '../../assets/images/CreditCardImage1.png';

import PromptPay_logo from '../../assets/images/PromptPay-logo.png';

const QRCodePopUP = ({
  open,
  onClose,
  language,
  tokens,
  bank,
  etaxData,
  orderId,
  companyName,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const installmentBank = bank?.find((item) => item.payType.startsWith('QR'));
  const bankDetails = installmentBank?.banks || [];
  // const bankDetails = bank?.[0]?.banks || [];

  const [qrOpen, setQrOpen] = useState(false);
  const [qrCreditOpen, setQrCreditOpen] = useState(false);
  const [qrAllInOneOpen, setQrAllInOneOpen] = useState(false);

  const [qrCodeImage, setQrCodeImage] = useState('');
  const [merchId, setMerchantId] = useState('');
  const [callCompany, setCallCompany] = useState('');
  const [paymentRefId, setPaymentRefId] = useState('');
  const [intervalId, setIntervalId] = useState(null);
  const [bankImage, setBankImage] = useState('');
  const [nameAccount, setNameAccount] = useState('');
  const [accountNumber, setAccuontNumber] = useState('');
  const checkInterval = useRef(null);

  const handleCloseQrPopup = () => {
    setQrOpen(false);
    setSelectedMethod('');
  };

  const handleCloseQrCreditPopup = () => {
    setQrCreditOpen(false);
    setSelectedMethod('');
  };

  const handleCloseQrAllinOnePopup = () => {
    setQrAllInOneOpen(false);
    setSelectedMethod('');
  };

  const qrOptions = [
    {
      label: 'QR Code',
      value: 'QR Code',
      icon: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        >
          <img
            src={PromptPay_logo}
            alt="Thai QR Logo"
            style={{
              height: 40,
            }}
          />
        </div>
      ),
    },
    {
      label: 'QR Code',
      value: 'QR Code - SCB',
      icon: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '32px',
            marginBottom: '32px',
          }}
        >
          <img
            src={PromptPay_logo}
            alt="Thai QR Logo"
            style={{
              height: 45,
            }}
          />
        </div>
      ),
    },
    {
      label: 'QR Code',
      value: 'QR Code - CIMB',
      icon: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '32px',
            marginBottom: '32px',
          }}
        >
          <img
            src={PromptPay_logo}
            alt="Thai QR Logo"
            style={{
              height: 45,
            }}
          />
        </div>
      ),
    },
    {
      label: 'QR Code Credit',
      value: 'QR Code Credit Card',
      icon: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '32px',
            marginBottom: '32px',
          }}
        >
          <img
            src={creditcardLogo}
            alt="Thai QR Logo"
            style={{
              height: 45,
            }}
          />
        </div>
      ),
    },
    {
      label: 'QR All In One',
      value: 'QR Code PromptPay Credit Card',
      icon: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        >
          <img
            src={PromptPay_logo}
            alt="PromptPay Logo"
            style={{ height: 40 }}
          />
          <img
            src={creditcardLogo}
            alt="Credit Card Logo"
            style={{ height: 40 }}
          />
        </div>
      ),
    },
  ];

  const filteredQrOptions = qrOptions
    .map((option) => {
      const matchedBank = bankDetails.find((b) => b.name === option.value);
      if (matchedBank) {
        return {
          ...option,
          bankName: matchedBank.bankName,
          // icon: matchedBank.icon,
          fee: matchedBank.fee,
          total_amount: matchedBank.total_amount,
          payType: matchedBank.payType,
        };
      }
      return null;
    })
    .filter(Boolean);
  const handlePaymentClick = async () => {
    // setIsLoading(true);
    if (
      selectedMethod.payType === 'QR' ||
      selectedMethod.payType === 'QR-SCB'
    ) {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${selectedMethod.payType} ${selectedMethod.bankName} ${
              etaxData?.branchCode ?? ''
            } ${etaxData?.tax ?? ''} ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: selectedMethod.payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrOpen(true);
          setQrCodeImage(data.imageQR);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);

          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    } else if (selectedMethod.payType === 'QRCS') {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${selectedMethod.payType} ${selectedMethod.bankName} ${
              etaxData?.branchCode ?? ''
            } ${etaxData?.tax ?? ''} ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: selectedMethod.payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        // setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrCreditOpen(true);
          setQrCodeImage(data.imageQR);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);

          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    } else if (selectedMethod.payType === 'QRPPCS') {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${selectedMethod.payType} ${selectedMethod.bankName} ${
              etaxData?.branchCode ?? ''
            } ${etaxData?.tax ?? ''} ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: selectedMethod.payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        // setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrAllInOneOpen(true);
          setQrCodeImage(data.paymentURL);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);
          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    }
  };

  const checkPaymentRefId = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_APIHOST}/check_callback`,
        { headers: { Authorization: tokens, sub: paymentRefId } },
      );
      if (response.status === 200) {
        const { rmsg, status, tagUrl, tagInput } = response.data;
        if (rmsg === 'pending') {
          navigate(`/transactionResult?status=${rmsg}`);
        }
        if (rmsg === 'cancel') {
          clearInterval(intervalId); // Stop the interval if the payment is canceled
          navigate(`/transactionResult?status=${rmsg}`);
        }
        clearInterval(intervalId); // Stop the interval if the payment is successful
        if (status === 'call merchant') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'call merchant jwt') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'do not call merchant') {
          clearInterval(intervalId);
          const etaxResponse = await api.post(
            `${process.env.REACT_APP_APIHOST}/etax/signandgetdocument`,
            { paymentRef: paymentRefId },
          );
          const data2 = etaxResponse.data || '';
          if (data2.status === 'OK') {
            clearInterval(intervalId);
            const urlPDF = data2.pdfURL;
            window.location.replace(
              `/transactionResult?status=${rmsg}&urlPDF=${encodeURIComponent(
                urlPDF || '',
              )}`,
            );
          } else {
            window.location.replace(`/transactionResult?status=${rmsg}`);
          }
        }
      }
    } catch (error) {
      console.error('Error during combined API call:', error);
    }
  };

  useEffect(() => {
    return () => {
      if (checkInterval.current) {
        clearInterval(checkInterval.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (qrOpen || qrAllInOneOpen || qrCreditOpen) {
      checkPaymentRefId();
      interval = setInterval(checkPaymentRefId, 10000);
    }
    return () => clearInterval(interval);
  }, [qrOpen, qrCreditOpen, qrAllInOneOpen]);

  const submitFormToMerchant = (tagUrl, tagInput) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(tagInput, 'text/html');
    const inputs = doc.querySelectorAll('input');
    const form = document.createElement('form');
    form.action = tagUrl;
    form.method = 'POST';
    form.style.display = 'none';
    inputs.forEach((input) => {
      const inputElement = document.createElement('input');
      inputElement.type = 'hidden';
      inputElement.name = input.name;
      inputElement.value = input.value;
      form.appendChild(inputElement);
    });
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '800px',
          },
        }}
      >
        <Loading isLoading={isLoading} />
        <DialogTitle>
          <Box sx={{ fontWeight: 'bold', fontSize: '20px', margin: '20px' }}>
            {language === 'TH'
              ? 'เลือกรูปแบบการชำระเงิน'
              : 'Select Payment Method'}
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ p: 1 }}
          >
            {filteredQrOptions.length === 0 ? (
              <Box sx={{ textAlign: 'center', width: '100%' }}>
                {language === 'TH'
                  ? 'ไม่พบช่องทางที่รองรับ'
                  : 'No available payment methods'}
              </Box>
            ) : (
              filteredQrOptions.map((option) => (
                <Grid item xs={12} md={4} key={option.value}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: '20px',
                      textAlign: 'center',
                      borderRadius: '15px',
                      cursor: 'pointer',
                      border:
                        selectedMethod?.value === option.value
                          ? '2px solid #0288d1'
                          : 'none',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      },
                    }}
                    onClick={() => setSelectedMethod(option)}
                  >
                    <Box>{option.icon}</Box>
                    {/* <Typography variant="subtitle1">{option.label}</Typography> */}
                    <Typography variant="body2" color="text.secondary">
                      {language === 'TH' ? 'ค่าธรรมเนียม' : 'Fee'}: {option.fee}{' '}
                      ฿
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {language === 'TH' ? 'ยอดชำระ' : 'Total Amount'}:{' '}
                      {option.total_amount} ฿
                    </Typography>
                  </Paper>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              mb: 3,
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#FC3A3A',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(252, 58, 58, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
            </Button>
            <Button
              onClick={handlePaymentClick}
              disabled={!selectedMethod}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#51D245',
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'rgba(81, 210, 69, 0.1)' },
              }}
            >
              {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <QRCode
        open={qrOpen}
        onClose={handleCloseQrPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <QRCredit
        open={qrCreditOpen}
        onClose={handleCloseQrCreditPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <QRAllInOne
        open={qrAllInOneOpen}
        onClose={handleCloseQrAllinOnePopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
    </>
  );
};

export default QRCodePopUP;
